// ContactRates Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import PriceText from '../../../common/common/price_text/price_text.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class ContactRates extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      note: PropTypes.string,
      items: PropTypes.array
    }
  }

  static get defaultProps () {
    return {
      title: '',
      note: '',
      items: []
    }
  }

  render () {
    return (
      <div className='contact-rates'>
        <h3 className='title'>
          <IntlMessage ident={this.props.title} />
        </h3>
        {this._renderItems()}
        <p className='note'>
          <IntlMessage ident={this.props.note} />
        </p>
      </div>
    )
  }

  /* Private Functions */
  _renderItems () {
    if (this.props.items && this.props.items.length > 0) {
      return this.props.items.map((item, idx) => (
        <div className='item' key={idx}>
          <span className='item-label'>{item.name}</span>
          <span className='item-value'>
            <PriceText value={item.amount} />
          </span>
        </div>
      ))
    }

    return (
      <div className='no-records'>
        <IntlMessage ident='contact.view.noRecordsInfo' />
      </div>
    )
  }
}

export default ContactRates
